













import Component, { mixins } from "vue-class-component";
import BlockTagsController from "./components/BlockTagsController.vue";
import BaseSlowConnection from "@/components/BaseSlowConnection";
import WithLoadingStatus from "@/mixins/WithLoadingStatus";
import WithTags from "@/mixins/WithTags";
import PageTitle from "@/components/PageTitle.vue";
import { TagInfo } from "@teacherskaya/api-provider/dist/api/TagsProvider";

@Component({
  components: { BlockTagsController, BaseSlowConnection, PageTitle },
})
export default class PageSettingsTags extends mixins(WithLoadingStatus, WithTags) {
  public isLoading: boolean = true;

  get tags(): TagInfo[] {
    return this.state.tags;
  }

  public save(newTag: TagInfo, BlockBaseFormInstance: any) {
    this.tagsUpdate(newTag).then(() => {
      BlockBaseFormInstance.clearAll();
    });
  }

  public create(title: string) {
    return this.tagsCreate(title);
  }

  public deleteTag(idTag: string) {
    return this.tagsDelete(idTag);
  }

  private mounted() {
    this.loadingStatusShow([this.tagsGet()]).then(() => {
      this.isLoading = false;
    });
  }
}
